import React from 'react';

export const UnauthorizedAccess: React.FC = () => {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center text-center p-6">
      <h1 className="text-2xl font-semibold text-red-600">Access Denied</h1>
      <p className="mt-4 text-gray-700">
        You don’t have permission to view this document.
      </p>
      <p className="text-gray-500 mt-2">
        If you believe this is a mistake, please contact the admin or document
        owner.
      </p>
      <button
        onClick={() => window.history.back()}
        className="mt-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        Go Back
      </button>
    </div>
  );
};
